import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, Collapse, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import ApproveModal from "../../Components/Common/ApproveModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";

// Formik
import * as Yup from "yup";
import { useFormik, Field, FieldArray } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetAdminState, getAdmin as onGetAdmin, addNewAdmin as onAddNewAdmin, updateAdmin as onUpdateAdmin, deleteAdmin as onDeleteAdmin, getAdminLoading } from "../../store/admin/action";

import defaultImg from "../../assets/images/users/user-dummy-img.jpg";

import PropTypes from "prop-types";
import withRouter from "../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";

const Admin = (props) => {
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [logo, setLogo] = useState(defaultImg);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, admins, isAdminCreated, isAdminSuccess, loading, error, companies, companyLoading, clients, clientLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    admins: state.Admin.admins,
    isAdminCreated: state.Admin.isAdminCreated,
    isAdminSuccess: state.Admin.isAdminSuccess,
    loading: state.Admin.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
    error: state.Admin.error,
  }));

  const [adminList, setAdminList] = useState([]);
  const [statusActive, setStatusActive] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [isButtonOpen, setIsButtonOpen] = useState(false);

  useEffect(() => {
    dispatch(onGetAdmin());
  }, []);

  useEffect(() => {
    if (!isEmpty(admins)) {
      let arr = [];
      (admins.paidPurchase || []).forEach(el => {
        el.source = "Invoice Pembelian";
        el.type = "paidPurchase";
        el.type_label = "Terbayar Pembelian <> Terbayar Hutang Keuangan (PAYABLE)";
        arr.push(el);
      });

      (admins.releasePurchase || []).forEach(el => {
        el.source = "Release Bayar Pembelian";
        el.type = "releasePurchase";
        el.type_label = "Terbayar Pembelian <> Release Bayar Keuangan (CASH OUT)";
        arr.push(el);
      });

      (admins.releaseTrx || []).forEach(el => {
        el.source = "Release Bayar Keuangan";
        el.type = "releaseTrx";
        el.type_label = "Terbayar Keuangan <> Release Bayar Keuangan (CASH OUT)";
        arr.push(el);
      });
      setAdminList(arr.map((el) => ({ ...el, isChecked: false })));
    }
    else {
      setAdminList([]);
    }
  }, [admins]);

  useEffect(() => {
    const hasChecked = adminList.some((item) => item.isChecked);
    setIsButtonOpen(hasChecked);
  }, [adminList]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);

  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = adminList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setAdminList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(() => [{
    id: "#",
    Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
    filterable: false,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      return (
        <div className="hstack gap-2 mt-4 mt-sm-0">
          <input
            type="checkbox"
            className="dataCheckbox me-2 form-check-input"
            checked={data.isChecked}
            onChange={() => {
              const updatedData = adminList.map((d) => (d.id === data.id && d.code === data.code ? { ...d, isChecked: !d.isChecked } : d));
              setAdminList(updatedData);
            }}
          />
        </div>
      );
    },
  },
  {
    Header: "Jenis Koreksi",
    filterable: true,
    accessor: "type_label",
    Cell: (cell) => {
      let data = cell.row.original;
      let statBank;
      switch (data.source) {
        case "Invoice Pembelian":
          statBank = <span className="badge text-uppercase badge-soft-success">{data.source}</span>;
          break;
        case "Release Bayar Pembelian":
          statBank = <span className="badge text-uppercase badge-soft-info">{data.source}</span>;
          break;

        case "Release Bayar Keuangan":
          statBank = <span className="badge text-uppercase badge-soft-info">{data.source}</span>;
          break;
        default:
          statBank = "";
          break;
      }
      return (
        <div>
          <div className="mb-1">{data.type_label}</div>
          <div className="hstack gap-2">
            {statBank}
          </div>
        </div>
      );
    },
  },
  {
    Header: "Cabang",
    filterable: true,
    accessor: "branch",
    Cell: (cell) => {
      let data = cell.row.original;
      return (
        <div>
          <div className="mb-1">{data.branch}</div>
          <span className="badge text-uppercase badge-soft-primary">{data.vendor}</span>
        </div>
      );
    },
  },
  {
    Header: "No Trx",
    accessor: (data) => data.code,
    filterable: true,
  },
  {
    Header: "No Trx Keuangan",
    accessor: (data) => data.trx_code,
    filterable: true,
  },
  {
    Header: "Nilai Trx",
    accessor: (data) => currencyFormat(data.amount),
    filterable: true,
  },
  {
    Header: "Nilai Hutang",
    accessor: (data) => data.trx_amount ? currencyFormat(data.trx_amount) : "-",
    filterable: true,
  },
  {
    Header: "Terbayar",
    accessor: (data) => data.paid ? currencyFormat(data.paid) : "-",
    filterable: true,
  },
  {
    Header: "Terbayar Keuangan",
    accessor: (data) => data.paid ? currencyFormat(data.trx_paid) : "-",
    filterable: true,
  },
  ],
    [adminList, userRole, userType, isCheckAll],
  );

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: adminList,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Status", "Email", "Telepon"],
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      simple: true,
    };
    dispatch(onGetAdmin(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setAdminList([]);
    setSearchValue("");
    setStatusActive([]);
    setGlobalFilter(undefined);
    dispatch(resetAdminState());
    dispatch(onGetAdmin({ simple: true }));
  };

  const [approveCorrection, setApproveCorrection] = useState(false);
  const approveCorrectionAll = () => {
    if (adminList.length > 0) {
      adminList.forEach((data) => {
        if (data.isChecked) {
          dispatch(onUpdateAdmin(data));
        }
      });
    }
  };

  useEffect(() => {
    if (isAdminCreated) {
      window.location.reload();
    }
  }, [isAdminCreated]);

  document.title = "Koreksi Keuangan | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <DeleteModal
        show={approveCorrection}
        title="Anda akan mengkoreksi data pembayaran!"
        btn="Ya, Lanjutkan"
        isApproval={true}
        onDeleteClick={() => {
          approveCorrectionAll();
          setApproveCorrection(false);
        }}
        onCloseClick={() => setApproveCorrection(false)}
      />
      <Container fluid>
        <BreadCrumb title="Koreksi Keuangan" pageTitle="Koreksi Keuangan" loading={loading}>
          <div className="flex-shrink-0">
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={12}>
            <Card>
              <CardBody className="pt-0">
                <Row className="mb-3">
                  <CardBody className="border border-top-0 border-end-0 border-start-0">
                    <form>
                      <Row>
                        <Col sm={2}>
                          <div className="me-2 mb-3 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={6}>
                          <div className="search-box me-2 mb-3 d-inline-block col-12">
                            <input
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              placeholder={`${count} Cari...`}
                              value={searchValue ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={3} className="col-xxl-3">
                          <div className="search-box me-2 mb-3 col-12">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Pilih Tanggal"
                              value={filterDate}
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }}
                            />
                            <i className="bx bx-calendar-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={1}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleFilter();
                              }}
                            >
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}
                            >
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Row>
                {isButtonOpen && (
                  <div className="mt-3">
                    <div className="fs-10 text-start">
                      <button className={"btn btn-info me-2 add-btn"} onClick={() => setApproveCorrection(true)}>
                        KOREKSI BAYAR SESUAI NILAI TRANSAKSI
                      </button>
                    </div>
                  </div>
                )}
                <div className="table-responsive table-card mb-1 mt-3">
                  <Table hover {...getTableProps()} className="align-middle table-nowrap">
                    <thead className="table-light">
                      {headerGroups.map((headerGroup, index) => (
                        <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                          {headerGroup.headers.map((column, index) => (
                            <th {...column.getSortByToggleProps()} className={"" + generateFilterable(column)} key={index}>
                              {column.render("Header")}
                              {generateSortingIndicator(column)}
                              {/* <Filter column={column} /> */}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                      {page.map((row) => {
                        prepareRow(row);
                        return (
                          <Fragment key={row.getRowProps().key}>
                            <tr>
                              {row.cells.map((cell, index) => {
                                return (
                                  <td {...cell.getCellProps()} key={index}>
                                    {cell.render("Cell")}
                                  </td>
                                );
                              })}
                            </tr>
                          </Fragment>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>


              </CardBody>
            </Card>
          </Col>

        </Row>
      </Container>
    </div>
  );
};

Admin.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(Admin));
